import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('LICENSE_HISTORY', ['TABLE'])
